import { ClientMappingField, ClientMappingValue, ClientMappingValueType } from "@avenueops/shared-types";

/**
 * A helper to cycle through mapping unit types
 */
export function switchMappingType<T extends ClientMappingField | ClientMappingValue>(update: (_: T) => void, unit: T): void {
  switch (unit.type) {
    case "VALUE":
      update({ ...unit, type: "OBJECT", fields: [] } as T);
      return;
    case "OBJECT":
      update({ ...unit, type: "LIST", values: [] } as T);
      return;
    case "LIST":
      update({ ...unit, type: "VALUE" } as T);
      return;
  }
}
